"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchStaticPageSuccess = exports.fetchStaticPage = exports.FETCH_STATIC_PAGE_FAIL = exports.FETCH_STATIC_PAGE_SUCCESS = exports.FETCH_STATIC_PAGE = void 0;

var _api = require("@modules/api");

var _mutator = _interopRequireDefault(require("./mutator"));

var _router = require("@modules/router");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ROOT = '@@staticPages';
var FETCH_STATIC_PAGE = "".concat(ROOT, "/FETCH_STATIC_PAGE");
exports.FETCH_STATIC_PAGE = FETCH_STATIC_PAGE;
var FETCH_STATIC_PAGE_SUCCESS = "".concat(ROOT, "/FETCH_STATIC_PAGE_SUCCESS");
exports.FETCH_STATIC_PAGE_SUCCESS = FETCH_STATIC_PAGE_SUCCESS;
var FETCH_STATIC_PAGE_FAIL = "".concat(ROOT, "/FETCH_STATIC_PAGE_FAIL");
exports.FETCH_STATIC_PAGE_FAIL = FETCH_STATIC_PAGE_FAIL;

var fetchStaticPage = function fetchStaticPage(slug) {
  var _next;

  return {
    type: _api.apiActions.CALL_API,
    call: FETCH_STATIC_PAGE,
    route: "/static/".concat(slug),
    schema: _mutator.default,
    next: (_next = {}, _defineProperty(_next, _api.apiActions.CALL_API_SUCCESS, fetchStaticPageSuccess), _defineProperty(_next, _api.apiActions.CALL_API_FAIL, _router.routerActions.flushTo.bind(null, '/error404')), _next)
  };
};

exports.fetchStaticPage = fetchStaticPage;

var fetchStaticPageSuccess = function fetchStaticPageSuccess(staticPage) {
  return {
    type: FETCH_STATIC_PAGE_SUCCESS,
    staticPage: staticPage
  };
};

exports.fetchStaticPageSuccess = fetchStaticPageSuccess;